import React, { useCallback, useEffect, useState } from 'react';
import { CiFlag1 } from 'react-icons/ci';
import AddProperty from './controls/AddProperty';
import ToggleView from './controls/ToggleView';
import CreateProgKey from './progKey/CreateProgKey';
import { isItem, K_INFO, LoadCycle, useConfigsDataContext } from '../../../providers/ConfigsDataContextProvider';
import { useConfigPathContext } from '../../../providers/ConfigPathContextProvider';
import RowContents from './RowContents';
import ConfigItem from './ConfigItem';
import { useItemListenerContext } from '../../../providers/ItemListenerContextProvider';
import './ConfigTable.css'

// --------------------   Static   ----------------------------//
const getSortedItems = (aNode) => {
  return Object.keys(aNode)
            .filter(keyName => keyName !== K_INFO)
            .filter(keyName => isItem(aNode[keyName]))
            .sort((a,b) => a.toLowerCase().localeCompare(b.toLowerCase()));
}

// --------------------   Items Table   -----------------------//
const ItemsTable = () => {
  const {configPath}                          = useConfigPathContext();
  const {getNode, loadCycle}                  = useConfigsDataContext();
  const {itemChanged}                         = useItemListenerContext();
  const [boswanaGrid, setBoswanaGrid]         = useState(false);
  const [showAddItem, setShowAddItem]         = useState(false);
  const [keyCreatedError, setKeyCreatedError] = useState(null);
  const [keyNameInProgress, setKeyNameInProgress] = useState(null);
  const [configRows, setConfigRows]           = useState(null);

  const toggleBoswana = useCallback(()=>{
    setBoswanaGrid(prev => !prev);
  }, []);


  useEffect(()=>{
    if (configPath || loadCycle === LoadCycle.Fetched) {
      const folder = getNode(configPath);
      if (folder) {
        const errInfo = folder[K_INFO]?.keyCreatedErrorInfo;
        const inProgressName = folder[K_INFO]?.keyNameInProgress;
        setKeyNameInProgress(inProgressName);
        setKeyCreatedError(errInfo);
        setShowAddItem(Boolean(errInfo) || Boolean(inProgressName));
        // console.log('[ItemsTable] [keyCreatedError: %s] [inProgressName: %s]', errInfo ? JSON.stringify(errInfo) : 'None', inProgressName);

        setConfigRows(getSortedItems(folder).map(progKey => (<RowContents key={`confrow-${progKey}`}>
              <ConfigItem folderPath={configPath} folder={folder} keyName={progKey} boswana={boswanaGrid} tabIx='1' key={`configRow-${progKey}`} />
              <div className={`configRowSep ${boswanaGrid ? 'boswanaRowSep' : ''}`} key={`configRowSep-${progKey}`} />
        </RowContents>)));        
      }
    }
  }, [configPath, boswanaGrid, getNode, itemChanged, loadCycle]);


  return (
    <div className='configTable'>
        <div className= {`newGen ${boswanaGrid ? 'boswanaGrid' : ''}`} key='configTableNewGen'>
          <div className='ctrlCol' key='ctrlCol'>
            <AddProperty onClick={() => setShowAddItem(true)} key='hdr-109'/>
          </div>
          {boswanaGrid && <div className='configHeader configTitle'> Propery Name <ToggleView toggle={toggleBoswana} cur={boswanaGrid} key='hdr-ttl'/></div>}
          {!boswanaGrid && <div className='configHeader configTitle'> Display Name <ToggleView toggle={toggleBoswana} cur={boswanaGrid} key='hdr-dsn'/></div>}
          {!boswanaGrid && <div className='configHeader configProgKey' key='hdr-cfk'> Config Key </div>}

          <div className='configHeader configValue' key='hdr-val'> Value </div>
          <div className='configHeader configNotes' key='hdr-nts'> Notes </div>
          <div className='configHeader configFlags' key='hdr-flg'> <CiFlag1 /> </div> 
          <div className='configHeader configModified' key='hdr-mod'> Modified </div>
          <div className='ctrlRight' key='hdr-rgt'>  </div>          
          
          <div className={`configSeparator ${boswanaGrid ? 'boswanaSeparator':''}`} key='hdr-sep'></div>

          <div/>

          {!boswanaGrid && <div/>}

          <div style={{minWidth: 320}} key='hdr-aditm'>
            {showAddItem && <div className='newPropWrapper'>
                                <CreateProgKey 
                                  hideMe={() => setShowAddItem(false)} 
                                  withError={keyCreatedError}
                                  inProgress={keyNameInProgress}
                                  />
                            </div>}
          </div>
          <div key='hdr-101'/>
          <div key='hdr-102'/>
          <div key='hdr-103'/>
          <div key='hdr-104'/>
          <div key='hdr-105'/>

          {configRows}

          {!configRows || configRows.length === 0 ? (
            <div className='emptyRows' key='empty-rows'>
            Create your first Config Item for this folder<p />
              <div className='emptyRowsDesc'> 
              Click
                <div className='addItem'> Add Item </div>
                <div className='addItemWrapper' key='add-item-wrapper'>
                  <AddProperty onClick={() => setShowAddItem(true)} key='addItemEmbed'/>
                </div>
            </div>              
            </div>
          ) : null}
          

          <div key='hdr-106-Footer-Left'> </div>
          <div key='hdr-107-Footer-Center'> </div>
          <div key='hdr-108-Footer-Right'> </div>
        </div>      
    </div>
  );
};

export default React.memo(ItemsTable);